import moment, { Moment } from 'moment';

class DateService {
    toLocal = (date: number): number => {
        return moment(date).subtract(moment(date).utcOffset(), 'minutes').valueOf();
    };

    toUtc = (date: number): number => {
        const dateAsMoment = moment(date);
        return moment.utc(dateAsMoment.format().slice(0, -6)).valueOf();
    };

    /**
     * Changes date format to local
     * @param date the date
     * @returns the transformed date
     */
    transformDate = (date?: Moment): Moment | undefined => {
        return date && moment.utc(date).local();
    };
}

const dateService: DateService = new DateService();
export default dateService;
